import {
  ALL_QUESTIONS,
  ADD_QUESTION,
  UPDATE_ANSWERS,
} from "../actions/questionActions";
import { formatQuestion } from "../../utils/helper";
import { loadQuestionState } from "../localStorage";

const initialState = loadQuestionState();

export const questionReducer = (state:any = initialState, action:any) => {
  switch (action.type) {
    case ALL_QUESTIONS:
      return {
        allQuestions: action.allQuestions,
      };
    case ADD_QUESTION:
      return {
        allQuestions: [...state.allQuestions, formatQuestion(action.info)],
      };
    case UPDATE_ANSWERS:
      const id = action.info.questionId;
      const selectedOption = action.info.selectedOption;
      const userId = action.info.author;
      const [question] = state.allQuestions.filter((q:any) => q.id === id);
      question[selectedOption].votes.push(userId);
      return { allQuestions: [...state.allQuestions] };
    default:
      return state;
  }
};
